import "react-native-gesture-handler";
import React from "react";
import { NativeBaseProvider, extendTheme } from "native-base";
import { Image, SafeAreaView } from "react-native";
import * as Font from "expo-font";
import { Asset } from "expo-asset";

import Navigation from "./navigation";
import { GestureHandlerRootView } from "react-native-gesture-handler";

const customComponents = {
  Heading: {
    baseStyle: {
      fontFamily: "Rajdhani-Bold",
    },
    defaultProps: {
      fontFamily: "Rajdhani-Bold",
    },
  },
  Text: {
    baseStyle: {
      fontFamily: "Avenir",
    },
    defaultProps: {
      fontFamily: "Avenir",
    },
  },
};

const config = {
  useSystemColorMode: false,
  initialColorMode: "dark",
};

const fontConfig = {
  Avenir: {
    300: {
      normal: "Avenir-Light",
    },
    400: {
      normal: "Avenir",
      italic: "Avenir-Italic",
    },
    700: {
      normal: "Avenir-Roman",
      italic: "Avenir-Roman-Italic",
    },
  },
  Rajdhani: {
    700: {
      normal: "Rajdhani-Bold",
    },
    300: {
      normal: "Rajdhani-Light",
    },
    400: {
      normal: "Rajdhani",
    },
    500: {
      normal: "Rajdhani-Medium",
    },
    600: {
      normal: "Rajdhani-SemiBold",
    },
  },
  Montserrat: {
    300: {
      normal: "Montserrat-Light",
    },
    400: {
      normal: "Montserrat",
    },
    500: {
      normal: "Montserrat-Medium",
    },
    600: {
      normal: "Montserrat-SemiBold",
    },
    700: {
      normal: "Montserrat-Bold",
    },
    900: {
      normal: "Montserrat-ExtraBold",
    },
  },
  fonts: {
    heading: "Rajdhani-Bold",
    body: "Avenir",
  },
};

// extend the theme
export const theme = extendTheme({
  fontConfig,
  config,
  components: customComponents,
});
type MyThemeType = typeof theme;
declare module "native-base" {
  interface ICustomTheme extends MyThemeType {}
}

function cacheImages(images: any[]) {
  return images.map((image) => {
    if (typeof image === "string") {
      return Image.prefetch(image);
    } else {
      return Asset.fromModule(image).downloadAsync();
    }
  });
}

async function cacheFonts() {
  await Font.loadAsync({
    Montserrat: require("./assets/fonts/montserrat/Montserrat-Regular.ttf"),
    "Montserrat-Bold": require("./assets/fonts/montserrat/Montserrat-Bold.ttf"),
    "Montserrat-ExtraBold": require("./assets/fonts/montserrat/Montserrat-ExtraBold.ttf"),
    "Montserrat-Italic": require("./assets/fonts/montserrat/Montserrat-Italic.ttf"),
    "Montserrat-Light": require("./assets/fonts/montserrat/Montserrat-Light.ttf"),
    "Montserrat-Medium": require("./assets/fonts/montserrat/Montserrat-Medium.ttf"),
    "Montserrat-MediumItalic": require("./assets/fonts/montserrat/Montserrat-MediumItalic.ttf"),
    "Montserrat-SemiBold": require("./assets/fonts/montserrat/Montserrat-SemiBold.ttf"),
    "Rajdhani-Light": require("./assets/fonts/rajdhani/Rajdhani-Light.ttf"),
    "Rajdhani-Bold": require("./assets/fonts/rajdhani/Rajdhani-Bold.ttf"),
    "Rajdhani-Medium": require("./assets/fonts/rajdhani/Rajdhani-Medium.ttf"),
    Rajdhani: require("./assets/fonts/rajdhani/Rajdhani-Regular.ttf"),
    "Rajdhani-SemiBold": require("./assets/fonts/rajdhani/Rajdhani-SemiBold.ttf"),
    Avenir: require("./assets/fonts/avenir/Avenir LT Std 45 Book.otf"),
    "Avenir-Light": require("./assets/fonts/avenir/Avenir LT Std 35 Light.otf"),
    "Avenir-Roman": require("./assets/fonts/avenir/Avenir LT Std 55 Roman.otf"),
    "Avenir-Italic": require("./assets/fonts/avenir/Avenir LT Std 45 Book Oblique.otf"),
    "Avenir-Light-Italic": require("./assets/fonts/avenir/Avenir LT Std 45 Book Oblique.otf"),
    "Avenir-Roman-Italic": require("./assets/fonts/avenir/Avenir LT Std 65 Medium Oblique.otf"),
  });
}

export default function App() {
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        const imageAssets = cacheImages([
          require("./assets/menu.png"),
          require("./assets/logo.png"),
          require("./assets/iart.png"),
          require("./assets/niss.png"),
          require("./assets/fmard.png"),
          require("./assets/iita.png"),
          require("./assets/crin.png"),
          require("./assets/nihort.png"),
          require("./assets/nifor.png"),
          require("./assets/blocks.png"),
          require("./assets/playicon.png"),
          require("./assets/background.png"),
          require("./assets/circular_text.png"),
          require("./assets/menu_btn.png"),
          require("./assets/woman_with_corn.jpg"),
          require("./assets/twirl1.png"),
          require("./assets/twirl2.png"),
          require("./assets/star3.png"),
          require("./assets/star4.png"),
          require("./assets/team_abuja.png"),
          require("./assets/team_lagos.png"),
          require("./assets/team_kenya.png"),
          require("./assets/truck.png"),
          require("./assets/man_on_cap.png"),
          require("./assets/bikes.png"),
          require("./assets/vectors/house.png"),
          require("./assets/vectors/search.png"),
          require("./assets/objectives/objectives1.png"),
          require("./assets/objectives/objectives2.png"),
          require("./assets/objectives/objectives3.png"),
          require("./assets/objectives/objectives4.png"),
          require("./assets/objectives/objectives5.png"),
          require("./assets/objectives/objectives6.png"),
          require("./assets/objectives/objectives7.png"),
          require("./assets/objectives/objectives8.png"),
          require("./assets/objectives/objectives9.png"),
          require("./assets/objectives/objectives10.png"),
          require("./assets/objectives/objectives11.png"),
          require("./assets/objectives/objectives12.png"),
          require("./assets/ffh_bg.png"),
          require("./assets/vectors/chevron-left.png"),
          require("./assets/digital.png"),
          require("./assets/udongo_logo.png"),
          require("./assets/rice_farm.png"),
          require("./assets/bike_truck.png"),
          require("./assets/big_truck.png"),
          require("./assets/grains.png"),
          require("./assets/vectors/hub.png"),
          require("./assets/vectors/handshake.png"),
          require("./assets/vectors/folder.png"),
          require("./assets/fortune_tv.png"),
          require("./assets/fortune_radio.png"),
          require("./assets/media_bgd.png"),
          require("./assets/bulk_blending.png"),
          require("./assets/playicon.png"),
          require("./assets/bubles.png"),
          require("./assets/industrial_plant.png"),
          require("./assets/vectors/blender.png"),
          require("./assets/smart_blenders.png"),
          require("./assets/blenders.png"),
          require("./assets/football_team.png"),
          require("./assets/ksu.png"),
          require("./assets/uniabuja.png"),
          require("./assets/akwaibom.png"),
          require("./assets/bauchi.png"),
          require("./assets/csr_bgd.png"),
          require("./assets/president.png"),
          require("./assets/vectors/search.png"),
          require("./assets/vectors/handshake.png"),
          require("./assets/crop_research/oilpalm.png"),
          require("./assets/nutrient_maps/map1.png"),
          require("./assets/nutrient_maps/map2.png"),
          require("./assets/nutrient_maps/map3.png"),
          require("./assets/nutrient_maps/map4.png"),
          require("./assets/nutrient_maps/map5.png"),
          require("./assets/nutrient_maps/map6.png"),
          require("./assets/nutrient_maps/map7.png"),
          require("./assets/nutrient_maps/map8.png"),
          require("./assets/nutrient_maps/map9.png"),
          require("./assets/nutrient_maps/map10.png"),
          require("./assets/nutrient_maps/map11.png"),
          require("./assets/soil-research-bg.png"),
          require("./assets/vectors/survey.png"),
          require("./assets/vectors/box.png"),
          require("./assets/vectors/chart.png"),
          require("./assets/vectors/plant.png"),
          require("./assets/vectors/survey.png"),
          require("./assets/vectors/finance.png"),
          require("./assets/crop_research/oilpalm.png"),
          require("./assets/crop_research/tomatoes.png"),
          require("./assets/crop_research/cocoa.png"),
          require("./assets/crop_research/wheat.png"),
          require("./assets/crop_research/potatoes.png"),
          require("./assets/crop_research/rice.png"),
          require("./assets/crop_research/soybean.png"),
          require("./assets/crop_research/sorghum.png"),
          require("./assets/crop_research/maize.png"),
          require("./assets/crop-research-bg.png"),
          require("./assets/partners/bsu.png"),
          require("./assets/partners/akwa.png"),
          require("./assets/partners/kadsu.png"),
          require("./assets/partners/npfl.png"),
          require("./assets/partners/uniabuja.png"),
          require("./assets/partners/binl.png"),
          require("./assets/partners/circum-farms.png"),
          require("./assets/partners/novus-agro.png"),
          require("./assets/partners/raregeode.png"),
          require("./assets/partners/thrive.png"),
          require("./assets/partners/upl.png"),
          require("./assets/partners/value-seeds.png"),
          require("./assets/partners/barnksforte.png"),
          require("./assets/partners/mas.png"),
          require("./assets/partners/nsia.png"),
          require("./assets/partners/springfield.png"),
          require("./assets/partners/babban-gona.png"),
          require("./assets/partners/iadr.png"),
          require("./assets/partners/dangona.png"),
          require("./assets/partners/palm-valley.png"),
          require("./assets/partners/abumfb.png"),
          require("./assets/partners/afex.png"),
          require("./assets/partners/thrive.png"),
          require("./assets/partners/arzikinnoma.png"),
          require("./assets/partners/intrio.png"),
          require("./assets/partners/archesa.png"),
          require("./assets/partners/syngenta.png"),
          require("./assets/partners/picture1.png"),
          require("./assets/partners/picture2.png"),
          require("./assets/partners/agra.png"),
          require("./assets/partners/olam.png"),
          require("./assets/partners/agrolog.png"),
          require("./assets/partners/tweakcentric.png"),
          require("./assets/partners/insigna.png"),
        ]);

        cacheFonts();

        // await Promise.all([...imageAssets, ...fontAssets]);
        await Promise.all([...imageAssets]);
      } catch (e) {
        console.warn(e);
      }
    }

    loadResourcesAndDataAsync();
  }, []);
  return (
    <GestureHandlerRootView>
      <NativeBaseProvider theme={theme}>
        <SafeAreaView>
          <Navigation />
        </SafeAreaView>
      </NativeBaseProvider>
    </GestureHandlerRootView>
  );
}
